import React from 'react';
import { StyleSheet, css } from 'aphrodite';

const styles = StyleSheet.create({
  wrap: {},
});

const NarrowType = (props) => {
  return (
    null
  );
}

export default NarrowType;


// WEBPACK FOOTER //
// ./src/nomad/NarrowType.jsx